import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { LanguageCode } from '@gbr-monorepo/interfaces';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { select, Store } from '@ngxs/store';
import { FooterComponent as SharedFooterComponent, HeaderComponent as SharedHeaderComponent } from 'shared-ui';
import { SetUserLanguage } from './auth/state/user.action';
import { UserState } from './auth/state/user.state';
import { ThemeService } from './shared/services/theme.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SharedHeaderComponent, RouterOutlet, SharedFooterComponent, TranslateModule]
})
export class AppComponent implements OnInit {
    private readonly store = inject(Store);
    private translate = inject(TranslateService);
    private theme = inject(ThemeService);
    private router = inject(Router);

    protected readonly selectedLang = select(UserState.userLanguage);
    protected readonly user = select(UserState.user);

    title = 'frontend-shs';

    ngOnInit(): void {
        this.routeToRedirect();
        this.translate.setDefaultLang('de');
        this.translate.use(this.selectedLang());
        this.theme.setTheme('light');
    }

    public changeLanguage(language: LanguageCode): void {
        this.store.dispatch(new SetUserLanguage({ language }));
    }

    private routeToRedirect(): void {
        const url = window.localStorage.getItem('redirectUrl');
        if (url) {
            void this.router.navigateByUrl(url);
            window.localStorage.removeItem('redirectUrl');
        }
    }
}
